module.exports = __webpack_public_path__ + "static/media/competencia.9dd92821.png";